import { useRef, useState } from "react";
import CompaniesList from "./_CompaniesList";

export default function CVMFilings() {
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(false);

    const [begin, setBegin] = useState(false);

    const searchInput = useRef(null);

    const handleSearchSubmit = function (event) {
        event.preventDefault();

        setLoading(true);

        const req = new Request("https://api.mziq.com/mzfilemanager/company/configuration?pageNumber=1&pageSize=1000", {
            body: JSON.stringify({ cvmCodes: [] }),
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            }),
        });

        fetch(req).then((body) =>
            body.json().then((res) => {
                if (res.success === true) {
                    if (searchInput.current.value) {
                        const newCompanies = res.data.cvmCompanies.filter((company) => {
                            return company.nome.toUpperCase().includes(searchInput.current.value.toUpperCase());
                        });

                        setCompanies(newCompanies);
                    } else {
                        setCompanies([]);
                    }

                    setBegin(true);
                    setLoading(false);
                } else {
                    console.error("REQUEST ERROR", res);
                }
            })
        );
    };

    return (
        <>
            <div className="pages__category_pointer" id="eventsCategoriesPointer"></div>
            <section className="category">
                <div className="container">
                    <form id="cvmFilters" onSubmit={handleSearchSubmit} className="form">
                        <input type="search" ref={searchInput} className="inputCvm" id="digitarEmpresas" placeholder={cvmFilingsSearchPlaceholder} />
                        <input type="submit" className="btnCvm" id="buscarEmpresas" value={searchTxt} />
                    </form>
                </div>
            </section>
            <section className="pages cvm-filings" style={{ paddingBottom: 32, minHeight: 80 }}>
                <section className="pageCVM">
                    <div className="container">
                        {companies.length === 0 && begin && loading === false ? <span className="noFiles">{noCompaniesTxt}</span> : <CompaniesList companies={companies} loading={loading} />}
                    </div>
                </section>
            </section>
        </>
    );
}
